import { post2 } from "@/shared/axios";
import useFranchiseHook from "@/shared/hooks/useFranchiseHook";
import useThemesHook from "@/shared/hooks/useThemesHook";
import { errorToast } from "@/shared/utils/helpers";
import { useMutation } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

const useThemeToAppsmenPost = () => {
  const { t } = useTranslation("");
  const [franchiseId] = useFranchiseHook();
  const { query } = useThemesHook();

  const mutation = useMutation({
    mutationFn: ({
      colorTemplateId,
      newName,
    }: {
      colorTemplateId: number;
      newName: string;
    }) =>
      post2(
        `internal/secure/pos/v1/websites/themes/copy/to/appsmen/${franchiseId}/${colorTemplateId}/${newName}`,
        {}
      ),
    onSuccess: () => {
      toast.success(t("success.create"));
      query.refetch();
    },
    onError: () => {
      errorToast();
    },
  });

  return mutation;
};

export default useThemeToAppsmenPost;
